// Generated by CoffeeScript 1.12.5
(function() {
  var React, Teact, elements, fn, fn1, i, j, len, len1, merge_elements, ref, ref1, tagName,
    slice = [].slice,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  React = require('react');

  elements = {
    regular: 'a abbr address article aside audio b bdi bdo blockquote body button canvas caption cite code colgroup datalist dd del details dfn div dl dt em fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup html i iframe ins kbd label legend li map mark menu meter nav noscript object ol optgroup option output p pre progress q rp rt ruby s samp script section select small span strong sub summary sup table tbody td textarea tfoot th thead time title tr u ul video',
    "void": 'area base br col command embed hr img input keygen link meta param source track wbr',
    obsolete: 'applet acronym bgsound dir frameset noframes isindex listing nextid noembed plaintext rb strike xmp big blink center font marquee multicol nobr spacer tt',
    obsolete_void: 'basefont frame'
  };

  merge_elements = function() {
    var a, args, element, i, j, len, len1, ref, result;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    result = [];
    for (i = 0, len = args.length; i < len; i++) {
      a = args[i];
      ref = elements[a].split(' ');
      for (j = 0, len1 = ref.length; j < len1; j++) {
        element = ref[j];
        if (indexOf.call(result, element) < 0) {
          result.push(element);
        }
      }
    }
    return result;
  };

  Teact = (function() {
    function Teact() {
      this.stack = null;
    }

    Teact.prototype.resetStack = function(stack) {
      var previous;
      if (stack == null) {
        stack = null;
      }
      previous = this.stack;
      this.stack = stack;
      return previous;
    };

    Teact.prototype.isSelector = function(string) {
      var ref;
      return string.length > 1 && ((ref = string.charAt(0)) === '#' || ref === '.');
    };

    Teact.prototype.parseSelector = function(selector) {
      var classes, i, id, klass, len, ref, ref1, token;
      id = null;
      classes = [];
      ref = selector.split('.');
      for (i = 0, len = ref.length; i < len; i++) {
        token = ref[i];
        token = token.trim();
        if (id) {
          classes.push(token);
        } else {
          ref1 = token.split('#'), klass = ref1[0], id = ref1[1];
          if (klass !== '') {
            classes.push(token);
          }
        }
      }
      return {
        id: id,
        classes: classes
      };
    };

    Teact.prototype.normalizeArgs = function(args) {
      var arg, attrs, classes, contents, dataAttrs, i, id, index, k, len, parsedSelector, selector, v;
      attrs = {};
      selector = null;
      contents = null;
      for (index = i = 0, len = args.length; i < len; index = ++i) {
        arg = args[index];
        if (arg != null) {
          switch (typeof arg) {
            case 'string':
              if (index === 0 && this.isSelector(arg)) {
                selector = arg;
                parsedSelector = this.parseSelector(arg);
              } else {
                contents = arg;
              }
              break;
            case 'function':
            case 'number':
            case 'boolean':
              contents = arg;
              break;
            case 'object':
              if (arg.constructor === Object && !React.isValidElement(arg)) {
                attrs = Object.keys(arg).reduce(function(clone, key) {
                  clone[key] = arg[key];
                  return clone;
                }, {});
              } else {
                contents = arg;
              }
              break;
            default:
              contents = arg;
          }
        }
      }
      if (parsedSelector != null) {
        id = parsedSelector.id, classes = parsedSelector.classes;
        if (id != null) {
          attrs.id = id;
        }
        if (classes != null ? classes.length : void 0) {
          if (attrs.className) {
            classes.push(attrs.className);
          }
          attrs.className = classes.join(' ');
        }
      }
      dataAttrs = attrs.data;
      if (typeof dataAttrs === 'object') {
        delete attrs.data;
        for (k in dataAttrs) {
          v = dataAttrs[k];
          attrs["data-" + k] = v;
        }
      }
      return {
        attrs: attrs,
        contents: contents,
        selector: selector
      };
    };

    Teact.prototype.crel = function() {
      var args, attrs, children, contents, el, previous, ref, ref1, tagName;
      tagName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
      if (tagName == null) {
        throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + tagName);
      }
      ref = this.normalizeArgs(args), attrs = ref.attrs, contents = ref.contents;
      switch (typeof contents) {
        case 'function':
          previous = this.resetStack([]);
          contents();
          children = this.resetStack(previous);
          break;
        default:
          children = contents;
      }
      if (children != null ? children.splice : void 0) {
        el = React.createElement.apply(React, [tagName, attrs].concat(slice.call(children)));
      } else {
        el = React.createElement(tagName, attrs, children);
      }
      if ((ref1 = this.stack) != null) {
        ref1.push(el);
      }
      return el;
    };

    Teact.prototype.pureComponent = function(contents) {
      var teact;
      teact = this;
      return function() {
        var children, previous;
        previous = teact.resetStack(null);
        children = contents.apply(teact, arguments);
        teact.resetStack(previous);
        return children;
      };
    };

    Teact.prototype.selfClosingTag = function() {
      var args, attrs, contents, ref, tagName;
      tagName = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
      ref = this.normalizeArgs(args), attrs = ref.attrs, contents = ref.contents;
      if (contents) {
        throw new Error("Teact: <" + tagName + "/> must not have content.  Attempted to nest " + contents);
      }
      return this.crel(tagName, attrs);
    };

    Teact.prototype.text = function(s) {
      var ref;
      if (!(s != null ? s.toString : void 0)) {
        return s;
      }
      if ((ref = this.stack) != null) {
        ref.push(s.toString());
      }
      return s.toString();
    };

    Teact.prototype.use = function(plugin) {
      return plugin(this);
    };

    Teact.prototype.tags = function() {
      var bound, boundMethodNames, fn, i, len, method;
      bound = {};
      boundMethodNames = [].concat('ie normalizeArgs script crel pureComponent text use'.split(' '), merge_elements('regular', 'obsolete', 'void', 'obsolete_void'));
      fn = (function(_this) {
        return function(method) {
          return bound[method] = function() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return _this[method].apply(_this, args);
          };
        };
      })(this);
      for (i = 0, len = boundMethodNames.length; i < len; i++) {
        method = boundMethodNames[i];
        fn(method);
      }
      bound.crel.text = bound.text;
      return bound;
    };

    return Teact;

  })();

  ref = merge_elements('regular', 'obsolete');
  fn = function(tagName) {
    return Teact.prototype[tagName] = function() {
      var args;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return this.crel.apply(this, [tagName].concat(slice.call(args)));
    };
  };
  for (i = 0, len = ref.length; i < len; i++) {
    tagName = ref[i];
    fn(tagName);
  }

  ref1 = merge_elements('void', 'obsolete_void');
  fn1 = function(tagName) {
    return Teact.prototype[tagName] = function() {
      var args;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return this.selfClosingTag.apply(this, [tagName].concat(slice.call(args)));
    };
  };
  for (j = 0, len1 = ref1.length; j < len1; j++) {
    tagName = ref1[j];
    fn1(tagName);
  }

  if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
    module.exports = new Teact().tags();
    module.exports.Teact = Teact;
  }

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/teact/lib/teact.js
// module id = 47
// module chunks = 0